import { getCarRepairList, insertCarRepair, getRepair } from "../../api/config/modules/CarRepair";

const state = {
  getCarRepairList: {},
  insertCarRepair: {},
  getRepair: {},
};

const mutations = {
  SET_GETCARREPAIRLIST: (state, getCarRepairList) => {
    state.getCarRepairList = getCarRepairList;
  },
  SET_INSERTCARREPAIR: (state, insertCarRepair) => {
    state.insertCarRepair = insertCarRepair;
  },
  SET_GETREPAIR: (state, getRepair) => {
    state.getRepair = getRepair;
  },
};

const actions = {
  GET_GETCARREPAIRLIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getCarRepairList(data)
        .then((res) => {
          commit("SET_GETCARREPAIRLIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_INSERTCARREPAIR: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      insertCarRepair(data)
        .then((res) => {
          commit("SET_INSERTCARREPAIR", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETREPAIR: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getRepair(data)
        .then((res) => {
          commit("SET_GETREPAIR", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
